import Link from 'next/link';
import React from 'react';
import { VisuallyHidden } from 'react-aria';

import Arrow2Right from '@/icons/small/Arrow-2-Right.svg';
import { type LinkTypes, linkTypes } from '@/lib';

import {
  StyledCopy,
  StyledHeadline,
  StyledLink,
  StyledRow,
  StyledTeaser,
} from './LocationTeaser.styled';

export interface ILocationTeaserProps {
  className?: string;
  subtitle: string;
  headline: string;
  image: React.ReactNode;
  link: {
    href: string;
    label: string;
    linkType: LinkTypes;
  };
}

export const LocationTeaser = ({
  className,
  headline,
  subtitle,
  image,
  link,
}: ILocationTeaserProps) => {
  return (
    <StyledTeaser className={className}>
      {image}
      <StyledHeadline size="h5" forwardedAs="h3" label={headline} />
      <StyledRow>
        <StyledCopy size="s" text={subtitle} />
        {link.linkType === linkTypes.internal ? (
          <Link href={link.href} passHref>
            <StyledLink>
              <VisuallyHidden>{link.label}</VisuallyHidden>
              <Arrow2Right />
            </StyledLink>
          </Link>
        ) : (
          <StyledLink href={link.href}>
            <VisuallyHidden>{link.label}</VisuallyHidden>
            <Arrow2Right />
          </StyledLink>
        )}
      </StyledRow>
    </StyledTeaser>
  );
};
